/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Risk_Mod_OptimalInputs */

const en_coach_risk_mod_optimal = /** @type {(inputs: Coach_Risk_Mod_OptimalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You are in a productive training phase, and your load ramp is moderately elevated. This is a fine line — keep pushing, but do not stack another big increase on top. Listen to your body.`)
};

const de_coach_risk_mod_optimal = /** @type {(inputs: Coach_Risk_Mod_OptimalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Produktive Trainingsphase, und die Belastungsrampe ist mäßig erhöht. Schmaler Grat — trainiere weiter hart, aber stapel keine weitere große Steigerung drauf. Hör auf deinen Körper.`)
};

/**
* | output |
* | --- |
* | "You are in a productive training phase, and your load ramp is moderately elevated. This is a fine line — keep pushing, but do not stack another big increase ..." |
*
* @param {Coach_Risk_Mod_OptimalInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const coach_risk_mod_optimal = /** @type {((inputs?: Coach_Risk_Mod_OptimalInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Risk_Mod_OptimalInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_coach_risk_mod_optimal(inputs)
	return de_coach_risk_mod_optimal(inputs)
});